import React from 'react';
import {Button, Nav} from 'react-bootstrap';
import {useAuth} from "../authprovider";
import {
    Link,
    useLocation
} from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function Navigationbar()  {
    let location = useLocation();
    const auth = useAuth();
    const user = auth.user;
    const { t, i18n } = useTranslation();

    let handleLoguot = ()=>{
        auth.signout()
    }

    const isActive = (path)=> path === location.pathname ? "active" : "";

    const changeLanguage = (lng)=>{
        i18n.changeLanguage(lng);
    }

    const currentLang = i18n.language || 'pl';

    return (
            <Nav className={"position-relative"} variant="tabs" defaultActiveKey={location.pathname}>
                { user.isAdmin &&
                    <>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/")}`} to="/">{t('nav.buildings')}</Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/videos")}`} to="/videos">{t('nav.videos')}</Link>
                        </Nav.Item>
                    </>
                }
                {user.isSteward &&
                    <>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/controll")}`} to="/controll">{t('nav.controlPanel')}</Link>
                        </Nav.Item>
                    </>

                }
                {user.isManager &&
                    <>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/controll")}`} to="/controll">{t('nav.controlPanel')}</Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/files")}`} to="/files">{t('nav.files')}</Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Link className={`nav-link ${isActive("/users")}`} to="/users">{t('nav.users')}</Link>
                        </Nav.Item>
                    </>
                }

                <div className={"position-absolute"} style={{top: "2px", right: "8rem"}}>
                    <Button
                        size="sm"
                        variant={currentLang.startsWith('pl') ? "warning" : "outline-warning"}
                        className={"me-1"}
                        onClick={()=>changeLanguage('pl')}
                    >
                        {t('nav.langPl')}
                    </Button>
                    <Button
                        size="sm"
                        variant={currentLang.startsWith('en') ? "warning" : "outline-warning"}
                        onClick={()=>changeLanguage('en')}
                    >
                        {t('nav.langEn')}
                    </Button>
                </div>

                <Button name={"Wyloguj"} onClick={handleLoguot} className={"position-absolute"} style={{"top": "2px", "right": "2rem"}} variant="outline-warning">
                    {t('nav.logout')}
                </Button>
            </Nav>
        );

}

